const u = navigator.userAgent
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

const androidFunction = (callback) => {
  console.log('#Android#')
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', function() {
      callback(window.WebViewJavascriptBridge)
    }, false)
  }
}

const iosFunction = (callback) => {
  console.log('#iOS#')
  if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
  window.WVJBCallbacks = [callback]
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

window.setupWebViewJavascriptBridge = isAndroid ? androidFunction : iosFunction

/**
 * 处理推送通知点击事件
 * 当用户点击推送通知时，原生会调用此方法
 * 检查用户是否为蘑菇房用户，如果是则跳转到蘑菇房页面
 * @param {string} notificationData - 推送通知数据JSON字符串
 */
// window.notifyToH5CMD = function(notificationData) {
//   console.log('=== notifyToH5CMD 被调用 ===')
//   console.log('收到推送通知点击事件，数据:', notificationData)
//   console.log('数据类型:', typeof notificationData)
//   console.log('参数数量:', arguments.length)
//
//   // 解析通知数据
//   let notification = null
//   if (notificationData) {
//     try {
//       notification = JSON.parse(notificationData)
//       console.log('解析后的通知数据:', notification)
//     } catch (error) {
//       console.error('解析通知数据失败:', error)
//       console.log('原始数据:', notificationData)
//     }
//   }
//
//   // 获取Vue实例和路由
//   const app = document.querySelector('#app').__vue__
//   console.log('Vue应用实例:', app)
//
//   if (!app) {
//     console.warn('Vue应用实例未找到，等待页面加载...')
//     // 如果Vue实例还没准备好，等待一段时间再重试
//     setTimeout(() => {
//       const retryApp = document.querySelector('#app').__vue__
//       if (retryApp) {
//         console.log('重试获取Vue实例成功')
//         handleNotificationJump(retryApp, notification)
//       } else {
//         console.error('重试后仍未找到Vue实例')
//       }
//     }, 2000)
//     return
//   }
//
//   handleNotificationJump(app, notification)
// }

/**
 * 处理通知跳转逻辑
 */
// function handleNotificationJump(app, notification) {
//   const router = app.$router
//   const store = app.$store
//
//   console.log('路由实例:', router)
//   console.log('Store实例:', store)
//
//   // 检查用户信息
//   const userInfo = store.getters.userInfo
//   console.log('用户信息:', userInfo)
//   console.log('是否为蘑菇房用户:', userInfo && userInfo.isMushroomUser === 1)
//
//   if (userInfo && userInfo.isMushroomUser === 1) {
//     console.log('用户是蘑菇房用户，准备跳转...')
//     // 延迟1秒后跳转到蘑菇房页面，确保页面完全加载
//     setTimeout(() => {
//       console.log('执行跳转到蘑菇房页面')
//       try {
//         router.push('/mush')
//         console.log('跳转命令已执行')
//       } catch (error) {
//         console.error('跳转失败:', error)
//       }
//     }, 1000)
//   } else {
//     console.log('用户不是蘑菇房用户，不进行跳转')
//   }
// }

if (isAndroid) {
  window.setupWebViewJavascriptBridge(function(bridge) {
    // 注册 H5 界面的默认接收函数（与安卓交互时，不注册这个事件无法接收回调函数）
    bridge.init(function(msg, responseCallback) {
      message.success(msg)
      responseCallback('J callback N')
    })
  })
}
